import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { EpsTrendItem } from "../types";
import { loadSecurityEpsTrend } from "../thunks/getSecurityEpsTrendThunk";

export const useDisplaySecurityEpsTrend = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    EpsTrendItem | undefined
  >((store) => store.data.reports.securityStatistics.displaySecurityEpsTrend);

  const displayedStatisticsepstrend =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadSecurityEpsTrend( symbol));
    }
  }, [dispatch, symbol]);

  return displayedStatisticsepstrend;
};